exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-modal-noscroll]{overflow:hidden}body[data-modal-noscroll] .header-main-wrapper,body[data-modal-noscroll] .layout-default .nav-menu-mobile,body[data-modal-noscroll] .layout-default .nav-menu-mobile-bar,body[data-modal-noscroll] .st-btn.scroll-top{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03d1791b","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./src/components/modal/default/body.styl
// module id = 755d990812574895b08f
// module chunks = 0